import defaultsDeep from 'lodash/defaultsDeep';
import mapValues from 'lodash/mapValues';
import has from 'lodash/has';
import cloneDeep from 'lodash/cloneDeep';

export const defPermissions = {
  appointments: {
    book: true,
    view: true,
    show_contact_info: true,
    modify: true,
    history: true,
    cancel: true,
  },
  clients: {
    view: true,
    modify: true,
  },
  services: {
    view: true,
    modify: true,
  },
  bankAccount: {
    view: true,
    modify: true,
  },
  profile: {
    view: true,
    modify: true,
  },
  reports: {
    view: true,
  },
  barberSettings: {
    view: true,
    modify: true,
  },
  settings: {
    view: true,
    modify: true,
  },
  barbers: {
    view: true,
    modify: true,
  },
  timeTrack: {
    view: true,
  },
  products: {
    view: true,
    modify: true,
  },
  inventory: {
    modify: true,
  },
  dashboard: {
    view: true,
  },
  analytics: {
    view: true,
  },
  register: {
    view: true,
  },
  cashRegister: {
    view: true,
  },
  dailySummary: {
    view: true,
  },
  dailySummaryHistory: {
    view: true,
  },
  taxes: {
    view: true,
    modify: true,
  },
  discounts: {
    view: true,
    modify: true,
  },
  promos: {
    view: true,
    modify: true,
  },
  waitingList: {
    view: true,
    modify: true,
  },
  blockTime: {
    modify: true,
  },
  customCharge: {
    view: true,
  },
  autoPayout: {
    view: true,
    modify: true,
  },
};

export const fallbackBarberRegisterPermissions = {
  cashRegister: {
    view: false,
    modify: false,
  },
  dailySummary: {
    view: false,
  },
  dailySummaryHistory: {
    view: false,
  },
  blockTime: {
    modify: false,
  },
  engage: {
    view: false,
  },
};

export const mapPermissions = (permissions) => {
  const data = cloneDeep(permissions);
  return mapValues(data, (permission) => {
    if (has(permission, 'add') || !has(permission, 'modify')) {
      return permission;
    }

    permission.add = permission.modify; // eslint-disable-line no-param-reassign
    return permission;
  });
};

export const restrictive = () => mapValues(defPermissions, permission => mapValues(permission, () => false));

const defaultPermissions = userPermissions => defaultsDeep({}, mapPermissions(userPermissions), defPermissions);

export const restrictivePermissions = userPermissions =>
  defaultsDeep({}, mapPermissions(userPermissions), restrictive());

export const defaultShopPermissions = userPermissions => defaultPermissions({
  ...userPermissions,
  workHours: {
    view: true,
    modify: true,
    add: true,
  },
});

export const defaultBarberPermissions = userPermissions => defaultPermissions({
  ...fallbackBarberRegisterPermissions,
  ...userPermissions,
});

export const defaultBrandPermissions = userPermissions => defaultPermissions({
  ...userPermissions,
  workHours: {
    view: true,
    modify: true,
    add: true,
  },
});

export default defaultPermissions;
